(function() {
    angular
        .module("app")
        .controller("DeleteMessageBoardModalController", DeleteMessageBoardModalController)

    DeleteMessageBoardModalController.$inject = [
        "$state",
        "$scope",
        "$uibModalInstance",
        "messageBoardsService",
        "userMessagingService",
        "messageBoard"
    ]

    function DeleteMessageBoardModalController(
        $state,
        $scope,
        $uibModalInstance,
        messageBoardsService,
        userMessagingService,
        messageBoard
    ){
        "use strict"

        $scope.messageBoard = messageBoard

        $scope.ok = function() {
            var success = function() {
                gtag("event", "delete_device", { device_id: messageBoard.device.id })
                $state.go($state.$current, null, { reload: true }).then(() => {
                    userMessagingService.success("Message Board Successfully Deleted")
                })
            }

            var failure = function(error) {
                userMessagingService.error("Message Board Delete Failed: " + error)
            }

            $uibModalInstance.close(messageBoardsService.deleteMessageBoard(messageBoard.id, success, failure))
        }

        $scope.cancel = function() {
            $uibModalInstance.dismiss("cancel")
        }
    }
})()
